module.exports = __webpack_public_path__ + "643fc4a0eb651399ee5f2b1815e7a9d9.pdf";